'use client';

import React, { type ChangeEvent } from 'react';

import { PrimaryTabs } from '@depop/web-ui-kit/PrimaryTabs';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { ShopProfileSection } from '@/modules/activityTracker/constants';
import { useExtendedRouter } from '@/modules/routing/useExtendedRouter';
import { useActiveShopTab } from '@/modules/shop/hooks/useActiveShopTab';
import { useIsViewingOwnShop } from '@/modules/shop/hooks/useIsViewingOwnShop';
import { type ShopByUsernameResponse } from '@/modules/shop/types';

type Props = {
  seller: ShopByUsernameResponse;
};

export function ShopNavigation({ seller }: Props) {
  const tShop = useTranslations('shop');
  const isViewingOwnShop = useIsViewingOwnShop();
  const { tab } = useActiveShopTab();
  const router = useExtendedRouter();

  function handleTabChange(sectionName: ShopProfileSection) {
    if (sectionName === ShopProfileSection.Shop) {
      router.push(`/${seller.username}/`);
    } else {
      router.push(`/${seller.username}/${sectionName}/`);
    }
  }

  const tabs = isViewingOwnShop
    ? [
        {
          id: ShopProfileSection.Shop,
          label: tShop('Selling'),
          value: ShopProfileSection.Shop,
        },
        {
          id: ShopProfileSection.Likes,
          label: tShop('Likes'),
          value: ShopProfileSection.Likes,
        },
        {
          id: ShopProfileSection.Saved,
          label: tShop('Saves'),
          value: ShopProfileSection.Saved,
        },
      ]
    : [
        {
          id: ShopProfileSection.Shop,
          label: tShop('Shop'),
          value: ShopProfileSection.Shop,
        },
        {
          id: ShopProfileSection.Likes,
          label: tShop('Likes'),
          value: ShopProfileSection.Likes,
        },
      ];

  return (
    <div className={clsx(styles.wrapper, styles.tabsWrapper)}>
      <PrimaryTabs
        tabs={tabs}
        activeValue={tab}
        name="shop-navigation-tabs"
        className={styles.primaryTabs}
        onChange={(e: ChangeEvent) => {
          handleTabChange(e.target.id as ShopProfileSection);
        }}
      />
    </div>
  );
}
